// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6b08ee23","453":"c8431e5d","455":"6af1cff6"}[chunkId] + ".chunk.js";
};